import { createApp } from 'vue'
import ExampleComponent from './ExampleComponent.vue'

const ExampleElements = document.querySelectorAll('.Example-vue')

Array.prototype.forEach.call(ExampleElements, function (exampleElement) {
  createApp(ExampleComponent, {
    // quizId: parseInt(quizElement.getAttribute('data-quiz-id')),
  }).mount(exampleElement)
})
// console.log('test')
